var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "#DFE7C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52148 15.3V13.95H13.5215V15.3H4.52148ZM9.02148 12.6C7.82148 12.6 6.89336 12.2287 6.23711 11.4862C5.58086 10.7437 5.25273 9.75958 5.25273 8.53383V2.69995H7.07542V8.64539C7.07542 9.30601 7.24061 9.84276 7.57098 10.2556C7.90136 10.6685 8.38505 10.875 9.02205 10.875C9.65917 10.875 10.1429 10.6685 10.4731 10.2556C10.8032 9.84276 10.9683 9.30601 10.9683 8.64539V2.69995H12.7902V8.53383C12.7902 9.75958 12.4621 10.7437 11.8059 11.4862C11.1496 12.2287 10.2215 12.6 9.02148 12.6Z",
    fill: "#2D3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineHover);
export default __webpack_public_path__ + "static/media/Underline-Hover.020377b26a6daa8ea884c4c24e4e2544.svg";
export { ForwardRef as ReactComponent };